<template>
  <div class="chat-content" ref="chatContent">
    <transition-group name="fade" tag="div">
      <div
        v-for="(msg, index) in messages"
        :key="msg.id || index"
        :class="['chat-message-wrapper', msg.isUser ? 'user' : 'bot']"
      >
        <!-- Standalone live reasoning (during loading) -->
        <ReasoningSteps
          v-if="msg.reasoningLoading"
          :steps="msg.reasoningSteps"
          :isLoading="true"
        />
        <!-- Regular message, optionally with embedded reasoning toggle -->
        <div v-else class="message-with-reasoning">
          <ReasoningSteps
            v-if="msg.reasoningSteps && !msg.reasoningLoading"
            :steps="msg.reasoningSteps"
            :isLoading="false"
          />
          <ChatMessage
            :text="msg.text || ''"
            :copyText="msg.copyText"
            :documents="msg.documents"
            :isUser="msg.isUser"
            :canBeCopied="msg.canBeCopied"
            :options="msg.options"
            @feedback="(sentiment) => $emit('feedback', sentiment, msg)"
          />
          <ActionConfirmation
            v-for="action in msg.pendingActions || []"
            :key="action.actionId"
            :action="action"
            :busy="
              busyAction && busyAction.actionIds.includes(action.actionId)
                ? busyAction.decision
                : null
            "
            :disabled="actionsDisabled"
            @apply="$emit('action', 'apply', action, msg)"
            @cancel="$emit('action', 'cancel', action, msg)"
          />
          <ApplyAllButton
            v-if="msg.pendingActions && msg.pendingActions.length > 1"
            :actions="msg.pendingActions"
            :busyAction="busyAction"
            :disabled="actionsDisabled"
            @apply-all="(actions) => $emit('apply-all', actions, msg)"
          />
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import ActionConfirmation from './ActionConfirmation';
import ApplyAllButton from './ApplyAllButton';
import ChatMessage from './ChatMessage';
import ReasoningSteps from './ReasoningSteps';

export default {
  components: {
    ActionConfirmation,
    ApplyAllButton,
    ChatMessage,
    ReasoningSteps,
  },
  props: {
    messages: {
      type: Array,
      required: true,
    },
    // { actionIds, decision, all } of the Apply, Cancel or Apply all click in
    // flight.
    busyAction: {
      type: Object,
      default: null,
    },
    actionsDisabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.scrollToBottom();
  },
  updated() {
    this.scrollToBottom();
  },
  methods: {
    scrollToBottom() {
      const { scrollHeight, clientHeight } = this.$refs.chatContent;
      this.$refs.chatContent.scrollTop = scrollHeight - clientHeight;
    },
  },
};
</script>

<style scoped>
.chat-content {
  padding: 5px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.chat-content::-webkit-scrollbar {
  width: 8px;
}

.chat-content::-webkit-scrollbar-thumb {
  background: #5b3ea5;
  border-radius: 5px;
}

.chat-content::-webkit-scrollbar-track {
  background: #ececec;
}

.chat-message-wrapper {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
}

.chat-message-wrapper:last-child {
  margin-bottom: 0;
}

.chat-message-wrapper.user {
  justify-content: flex-end;
}

.chat-message-wrapper.bot {
  justify-content: flex-start;
}

.message-with-reasoning {
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.fade-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
